<template>
  <div class="Login">
    <v-form v-model="valid">
      <v-container>
        <v-layout row wrap>
          <div id="log">
            <h1 id="regHeading">Anmelden:</h1>
            <v-divider></v-divider>
            <v-flex>
              <v-text-field label="E-Mail *" class="txtField" v-model="eMail" :rules="emailRules" required></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field label="Passwort" class="txtField" v-model="password" required :type="'password'"></v-text-field>
            </v-flex>
            <div v-if="!$store.state.auth.loading && !loading">
              <v-btn color="blue" @click="login" small class="ma-2">
                <span style="color: white;">Absenden</span>
              </v-btn>
              <v-btn color="blue" @click="password_forget" outlined small>
                <span>Passwort vergessen?</span>
              </v-btn>
            </div>
            <div v-else>
              <v-progress-linear
                color="blue accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
              <v-alert v-if="error && !$store.state.auth.loading  && errorText !== ''" type="error" outlined>
                {{errorText}}
              </v-alert>
              <v-alert v-if="$store.state.auth.error !== null && !$store.state.auth.loading  && $store.state.auth.error.statusText !== ''" type="error" outlined>
                {{$store.state.auth.error.statusText}}
              </v-alert>
              <v-alert v-if="!error && !loading && successText!==''" type="info" outlined>
                {{successText}}
              </v-alert>
          </div>
          <v-dialog v-model="dialog" persistent max-width="290" :retain-focus="false">
              <v-card>
                <v-card-title class="headline">Soll ihr Passwort zurückgesetzt werden?</v-card-title>
                <v-card-text>Beim Bestätigen wird eine Email an ihre angebeben Adresse gesendet.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue" text @click="dialog = false">Nein</v-btn>
                  <v-btn
                    color="blue"
                    text
                    outlined
                    @click="dialog = false; reset_pw()"
                  >Ja</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import {API_URL} from "../config";

export default {
  name: "login",
  data() {
    return {
      dialog:false,
      error:false,
      errorText:"",
      done: false,
      successText: "",
      valid: false,
      loading: false,
      eMail: "",
      password: "",
      emailRules: [
        v => !!v || 'E-mail ist erforderlich',
        v => /.+@.+/.test(v) || 'E-mail muss gültig sein',
      ],
    };
  },
  methods: {
    login() {
      console.log(this.valid);
      console.log(process);
      if (!this.valid) {
        return
      }

      var cred = { email: this.eMail.toLowerCase(), 
        password: this.password }
      console.log('login....', cred)
      this.$store.dispatch('auth/auth', cred)

      // this.$store.commit("setOnline");
      // this.$store.commit("updateMenue");
      // this.$store.commit("setUserData", ["David", "Kranebitter"]);
      // this.eMail = "";
      // this.password = "";
      // this.$router.push("/LogInfo");
    },
    password_forget() {
      console.log(this.eMail)
      if (this.eMail.trim() === ""){
        this.error = true
        this.errorText = "Bitte geben sie ihre Email ein."
	return;
      }
      this.error = false;
      this.dialog = true;
    },
    reset_pw() {
      var cred = { email: this.eMail.toLowerCase()};
      this.loading = true
      axios.post(API_URL + '/be/user/password_forget', cred).then((response) => {
        console.log('password_forget data: ', response.data)
        let data = response.data;
        this.loading = false
        this.done = true
        this.successText = "Email erfolgreich gesendet. Sehen sie in Ihrem Postfach nach."
      }).catch((res) => {
        this.loading = false;
        this.error = true
        this.errText = res.error
        console.log(res)
      })

    }
  }
};
</script>

<style>
.Login {
  text-align: center;
  opacity: 0.85;
  filter: alpha(opacity=85);
}

#log {
  background-color: white;
  width: 80%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
}

#regHeading {
  font-size: 200%;
}

#Login {
  float: left;
}

.txtField {
  width: 90%;
  margin-left: 5%;
}
</style>
